export const getLearningRecommendation = (pckPercentage: any, gpPercentage: any) => {
  const resourceTypeDescriptions = [
    {
      resourceType: 'Daily Learning series',
      purpose:
        'The Daily Learning Series (DLS) offers 5-minute micro-learning modules shared daily on the CENTA app. Each lesson includes strategies, videos, or activities to help teachers apply ideas in classrooms. Completing all lessons in a month earns a Digital Record of Completion, making learning simple and continuous.',
    },
    {
      resourceType: 'Reading Resources',
      purpose:
        'A Reading Article is a short, insightful piece written by teachers and experts, sharing real classroom ideas and strategies. It connects theory with practice, offering quick takeaways teachers can apply instantly making professional learning simple, engaging, and relatable.',
    },
    {
      resourceType: 'Pre recorded session',
      purpose:
        'CENTAlks or prerecorded sessions feature global experts who share best classroom practices and support professional growth. Teachers engage through polls, discussions, and feedback, making these sessions interactive and impactful.',
    },
  ];

  // We'll collect all links first
  const collectedLinks: Record<string, string[]> = {};

  const addLinks = (items: { resourceType: string; links: string[] }[]) => {
    items.forEach(({ resourceType, links }) => {
      const key = resourceType.trim().toLowerCase();
      if (!collectedLinks[key]) collectedLinks[key] = [];
      collectedLinks[key].push(...links);
    });
  };

  if (pckPercentage !== '') {
    const pck = Number(pckPercentage);
    if (pck >= 70) {
      addLinks([
        {
          resourceType: 'Reading Resources',
          links: [
            'https://centa.org/learning/metacognition---simplified',
            'https://centa.org/learning/experiential-learning--learning-by-doing',
          ],
        },
      ]);
    } else if (pck >= 40) {
      addLinks([
        {
          resourceType: 'Daily Learning series',
          links: ['https://centa.org/learning/bringing-scientific-thinking-into-daily-classroom-activities'],
        },
        {
          resourceType: 'Pre recorded session',
          links: ['https://centa.org/learning/empowering-learners-through-inquiry-autonomy-and-art'],
        },
      ]);
    } else {
      addLinks([
        {
          resourceType: 'Pre recorded session',
          links: [
            'https://centa.org/learning/beyond-memorization-nurturing-thinking-and-creativity-in-students',
            'https://centa.org/learning/teaching-as-an-art-and-a-science',
          ],
        },
      ]);
    }
  }

  if (gpPercentage !== '') {
    const gp = Number(gpPercentage);
    if (gp >= 70) {
      addLinks([
        {
          resourceType: 'Daily Learning series',
          links: ['https://centa.org/learning/teacher-leadership-mastering-coaching-and-mentorship-skills'],
        },
        {
          resourceType: 'Reading Resources',
          links: ['https://centa.org/learning/characteristics-of-high-quality-assessments'],
        },
        {
          resourceType: 'Pre recorded session',
          links: ['https://centa.org/learning/what-next-after-school-multidisciplinary-education-as-a-bridge-into-the-future'],
        },
      ]);
    } else if (gp >= 40) {
      addLinks([
        {
          resourceType: 'Daily Learning series',
          links: ['https://centa.org/learning/designing-dynamic-lessons-for-classrooms-best-practices-and-techniques'],
        },
        {
          resourceType: 'Reading Resources',
          links: ['https://centa.org/learning/planning-for-instruction'],
        },
        {
          resourceType: 'Pre recorded session',
          links: [
            'https://www.youtube.com/live/NAplUszLAhQ?feature=shared',
            'https://www.youtube.com/live/BATzqh9S_H8?feature=shared',
          ],
        },
      ]);
    } else {
      addLinks([
        {
          resourceType: 'Daily Learning series',
          links: [
            'https://centa.org/learning/language-of-instruction-strategies-resources-for-effective-teaching',
            'https://centa.org/learning/guide-to-developing-reflective-teaching-practices',
          ],
        },
        {
          resourceType: 'Reading Resources',
          links: [
            'https://centa.org/learning/the-magic-of-balancing-friendliness-and-firmness',
            'https://centa.org/learning/where-does-the-gap-exist-between-knowledge-and-actions',
          ],
        },
        {
          resourceType: 'Pre recorded session',
          links: ['https://www.youtube.com/live/caI8qHRGtmA?feature=shared'],
        },
      ]);
    }
  }

  // Merge with purpose descriptions
  const finalResult = Object.entries(collectedLinks).map(([key, links]) => {
    const resource = resourceTypeDescriptions.find(
      (r) => r.resourceType.trim().toLowerCase() === key
    );
    return {
      resourceType: resource?.resourceType ?? key,
      purpose: resource?.purpose ?? '',
      links,
    };
  });

  return finalResult;
};

